import type { NetworkErrorType } from '../../../utilities/errors/networkErrorType';

export const errorMessages: Record<NetworkErrorType, string> = {
  offline: 'You are offline. Check your connection.',
  timeout: 'Request timed out. Try again.',
  server_unreachable: 'Cannot reach server.',
  server_error: 'Server error. Please try again.',
  unknown: 'Something went wrong. Please try again.',
};

/**
 * Returns a user-facing message for a classified network error type.
 */
export function getNetworkErrorMessage(type: NetworkErrorType): string {
  return errorMessages[type];
}
